let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("eea4t")]).then(() => parcelRequire('8FBSU'));